import React, {Component, useEffect, useState} from 'react';
import {
    Button,
    Col,
    Image,
    ListGroup,
    ListGroupItem,
    Modal,
    Overlay,
    Panel,
    Popover,
    ProgressBar,
    Row
} from 'react-bootstrap';
import {withRouter} from 'react-router-dom'
import {create_order, getMockupRenderStatus} from './actions';
// import {connect} from 'react-redux';
import {SketchPicker} from 'react-color';
import Colour_Picker from '../../components/Colour_Picker';
import {toastr} from 'react-redux-toastr'
import {CardElement, Elements, injectStripe, StripeProvider} from 'react-stripe-elements';
import PenguinSlider from "../../components/PenguinSlider";
import ImageBox from "../../components/ImageBox";
import {Fetch, Image_Manipulation} from '../../utils';
import {hasMockupPerm} from '../../utils/subscriptionUtils';

import './style.css';

const { feline_fetch } = Fetch;
const { data_uri_to_blob } = Image_Manipulation;

const stripeOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#c23d4b',
      },
    }
  }
};


class Loader {
    static activate = () => {
        var rp = {
            w: window.document.getElementById('result_preview').clientWidth, 
            h: window.document.getElementById('result_preview').clientHeight
        };
        var rc = {
            w: window.document.getElementById('result_container').clientWidth, 
            h: window.document.getElementById('result_container').clientHeight
        };
        window.document.getElementById('result_overlay').style.width = Math.ceil(100 * rp.w / rc.w) + '%';
        window.document.getElementById('result_overlay').style.height = Math.ceil(100 * rp.h / rc.h) + '%';
        window.document.getElementById('result_overlay').style.marginLeft = Math.floor(100 * ((rc.w - rp.w) / 2) / rc.w) + '%';
        window.document.getElementById('result_loader').style.display = 'block';
        window.document.getElementById('result_overlay').style.display = 'block';
    }

    static hide = () => {
        window.document.getElementById('result_loader').style.display = 'none'
        window.document.getElementById('result_overlay').style.display = 'none'
    }

    static initialize = () => {
        var loader_elements = window.document.getElementsByClassName("bodymovin");
        const loadBMAnimation = loader_element => {
            var animation = window.bodymovin.loadAnimation({
                container: loader_element,
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: global.config.server_path + "uploads/loader-dai-small.json"
            });
        }

        for (var i = 0; i < loader_elements.length; i++) {
            loadBMAnimation(loader_elements[i]);
        }
    }
}


class Crop_Editor {
    static crop_editor = null;

    static initialize = async ({ user_image, active_layer }) => {
        try {
            if (!user_image) {
                var src = await window.fetchFileSrc('mockup_file')
                user_image = {src}
            }
            
            var desired_aspect = active_layer.upload_resolution.width / active_layer.upload_resolution.height;
            var img_temp = new window.Image();
            img_temp.crossOrigin = "anonymous";
            img_temp.onload = function(){
                Crop_Editor.crop_editor = new window.cropEditor(img_temp,desired_aspect,window.document.getElementById('crop_div'),user_image.cropDetails);
            }
            img_temp.src = user_image.src 
        } catch(err) {
            console.log('error init Crop_Editor.crop_editor ---?> ', err)
        }
    }

    static rotate_image = () => {
        if (Crop_Editor.crop_editor) {
            Crop_Editor.crop_editor.rotation += Math.PI/2
            if (Crop_Editor.crop_editor.rotation > 6.2) {
                Crop_Editor.crop_editor.rotation = 0
            }
            Crop_Editor.crop_editor.draw();
        }
    }

    static apply_zoom = event => {
        var value = event.target.value
        if (Crop_Editor.crop_editor) {
            Crop_Editor.crop_editor.zoom(value)
        }
    }

    static export_crop = () => {
        if (Crop_Editor.crop_editor) {
            return Crop_Editor.crop_editor.exportCrop()
        }
    }

    static destroy_editor = () => {
        if (Crop_Editor.crop_editor) {
            Crop_Editor.crop_editor = null;
        }
    }
};

window.ce = Crop_Editor


class _CardForm extends Component {
    state = {
        errorMessage: '',
    };

    handleChange = ({error}) => {
        if (error) {
            this.setState({errorMessage: error.message});
        }
    };

    handleSubmit = async (evt) => {
        try {
            evt.preventDefault();
            if (this.props.stripe) {
                var payment_method = await this.props.stripe.createPaymentMethod('card', this.state.cardElement)
                if (payment_method) {
                    await this.props.create_order();
                    payment_method = payment_method.paymentMethod.id;
                    var url = global.config.server_path + 'order/charge_stripe'; 
                    var charge_resp = await fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({payment_method, order_id: this.props.order_id})}) 
                    charge_resp = await charge_resp.json();
                    if (charge_resp.error) {
                        // Show error from server on payment form
                    } else {
                        if (charge_resp.data.requires_action) {
                            // Use Stripe.js to handle required card action
                            var payment_result = await this.props.stripe.handleCardAction(charge_resp.data.payment_intent_client_secret)
                            if (payment_result.error) {
                                return ;
                            }
                            var payment_intent_id = payment_result.paymentIntent.id;
                            var resp = await fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({payment_intent_id, order_id: this.props.order_id})}) 
                            resp = await resp.json();
                        } else {
                            var resp = charge_resp;
                        }
                        this.props.handle_result({ paymentDetails: charge_resp })
                        .then(resp => {
                            this.props.order_complete(resp);
                        })
                    }
                } else {
                    console.log('incorrect payment details')
                }
                // this.props.stripe.createToken().then(this.props.handleResult);
            } else {
                console.log("Stripe.js hasn't loaded yet.");
            }
        } catch(err) {
            console.log(err);
        }
    };

    handleReady = (element) => {
        this.setState({cardElement: element}) ;
    };

    render() {
        return (
            <div className="CardDemo">
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <label style={{width: '100%', margin: 'auto', paddingTop: 10, paddingBottom: 10}}>
                        <CardElement style={{padding: 10}} onChange={this.handleChange} onReady={this.handleReady} {...stripeOptions()} />
                    </label>
                    <div className="error" role="alert" style={{minWidth: 400, margin: 'auto'}}> {this.state.errorMessage} </div>
                    <button className="btn btn-blue btn-block">Pay</button>
                </form>
            </div>
        );
    }
}

const CardForm = injectStripe(_CardForm);


const Image_Crop_Modal = ({ show_image_crop_modal, hide_image_crop_modal, update_user_images ,is_dm}) => {
    try {

        return (
            <Modal show={show_image_crop_modal} onHide={hide_image_crop_modal}>
                <Modal.Header closeButton>
                  <Modal.Title>Crop selected image</Modal.Title>
                </Modal.Header>
                  <Modal.Body>  
                    <div id="crop_div" align="center">
                        Waiting for upload<br />
                        <img src={global.config.server_path+"public/images/loader.gif"} />
                    </div>
                  </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col xs={12} align="center" style={{marginBottom:"10px",marginTop:"-5px"}}>
                            <Button onClick={Crop_Editor.rotate_image} className={is_dm?"btn btn-orange-inverse":"btn btn-blue-inverse"}>⤾</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2}>
                        </Col>
                        <Col xs={8}>
                            <input type="range" min="1" max="100" onChange={Crop_Editor.apply_zoom} className="slider" id="zoom_slider"/>
                        </Col>
                        <Col xs={2}>
                        </Col>                          
                    </Row>
                    <Row className="text-center" style={{marginTop: "2rem"}}>
                        <Button onClick={update_user_images} className={is_dm?"btn btn-orange":"btn btn-blue"}>Crop</Button>        
                    </Row>
                </Modal.Footer>
            </Modal>
        );
    } catch(err) {
        console.log('error in image upload modal --> ', err);
        return ''
    }
}


const Image_Options_Modal = ({ show_image_options_modal, hide_image_options_modal, past_designs, activate_image_crop_modal, initiate_image_upload, is_dm }) => {
    try {
        const heading_style = {
            fontSize: 14,
            paddingBottom: 20,
            paddingRight: 10
        };

        return (
            <Modal show={show_image_options_modal} onHide={hide_image_options_modal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                    choose or upload image
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>  
                    <Button style={{ marginTop: 15, marginBottom: 30 }} className={is_dm?"btn btn-sm btn-orange btn-block":"btn btn-sm btn-blue btn-block"} onClick={initiate_image_upload}><span class="fa fa-upload"></span> Upload New Image</Button>
                    <hr className="or_divider"/>    
                    <Row style={heading_style}>
                        <Row style={{ paddingBottom: 5}}>
                            <b>Choose from your designs</b>
                        </Row>
                        <PenguinSlider id="past_design_slider" height={120} >
                            {past_designs.map((design, idx) => (
                                <ImageBox 
                                    key={'past_design_box_' + idx}
                                    on_click={ () => activate_image_crop_modal({ user_image: {src:global.config.server_path + design.thumbnail} }) }
                                    idx={idx}
                                    image_src={global.config.static_file_server_path + design.thumbnail}
                                    name={design.name}
                                />
                            ))}                             
                        </PenguinSlider>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    } catch(err) {
        console.log('error in image Options modal --> ', err);
        return ''
    }
}


const Payment_Modal = ({ show_payment_modal, hide_payment_modal, mockup, inputs, watermarked_image_src, payment_completion, user,is_dm}) => {
    try {
        //css
        const heading_style = {
            cursor: 'pointer', 
            fontFamily: 'Montserrat', 
            fontWeight: 400
        };

        const loader_overlay_style = {
            top: 0,
            position: 'absolute',
            background: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            width: '100%',
            height: '100%',
            fontSize: '18',
            marginLeft: '-15px',
            textAlign: 'center',
            paddingTop: 'calc(100% - 50px)',
        }

        //state
        const [ active_tab, set_active_tab ] = useState('stripe');
        const [ order_id, set_order_id ] = useState(null);
        const [ order_final, set_order_final ] = useState(false);
        const [ download_url, set_download_url ] = useState(null);
        const [ loader_active, set_loader_active ] = useState(false);
        const [ generation_success, set_generation_success ] = useState(false);
        const [render_progress, set_render_progress] = useState(0);

        //functions
        const erroroneous_case = () => {
            set_loader_active(false);
            set_generation_success(false);
            set_order_final(true);
        }

        const create_order = async () => {
            try {
                set_loader_active(true);
                var payment_mode = active_tab;
                var skus = [{
                    type: 'mockup',
                    inputs,
                    price: mockup.price,
                    mockup: mockup._id,

                }];
                var order_data = { payment_mode, skus };
                var order = await feline_fetch({ url: 'order/add', body: order_data });
                set_order_id(order._id);
                return order;
            } catch(err) {
                console.log('error in order creation -->>> ', err);
                erroroneous_case();
                console.error(err);
            }
        } 

        const confirm_order = async ({ id, paymentDetails }) => {
            try {
                if (!id) {
                    id = order_id;
                }
                return await feline_fetch({ url: 'order/confirm', body: { id, paymentDetails } }); 
            } catch(err) {
                console.error('error in confirm order ', err);
                erroroneous_case();
            }
        }

        const order_complete = (order) => {
            try {
                set_loader_active(false);
                set_order_final(true);
                // set_download_url(global.config.static_file_server_path + order.skus[0].output_file);
                set_generation_success(true);
                payment_completion();
            } catch(err) {
                console.error('error in order complete ', err);
                erroroneous_case();
            }
        }

        const direct_order_completion = async () => {
            try {
                set_order_final(true);
                set_generation_success(true);
                set_loader_active(true);
                var order = await create_order();
                order = await confirm_order({ id: order._id, paymentDetails: 'Designs AI subscription' });
                order_complete(order);
            } catch(err) {
                console.error('error in direct_order_completion ---> ', err);
                erroroneous_case();
            }

        }

        useEffect(() => {   
            if (show_payment_modal) {
                set_loader_active(false);
                set_active_tab('stripe');
                set_order_id(null);
                set_order_final(false);
                set_download_url(null);
                if (hasMockupPerm(user)) {
                    direct_order_completion();
                } 
            }
        }, [ show_payment_modal ]);

        const statusCheck = async () => {
            try {
                let currProgress = (render_progress + 100)/2;
                set_render_progress(currProgress);
                let data = await getMockupRenderStatus(order_id, 0);
                if (data.success === true) {
                    set_download_url(global.config.static_file_server_path + data.fileSrc);
                    set_order_id(null);
                }
            }
            catch (e) {
                console.error(e);
            }
        };

        var pollingCtr;

        useEffect(() => {
            if (order_id && order_final === true) {
                pollingCtr = setInterval(statusCheck, 2000);
                return  () => {
                    clearInterval(pollingCtr);
                }
            }
        }, [order_id]);

        // useEffect(() => {
        //     if (order_id) {
        //         console.log('order created ---> ', order_id);
        //     }
        // }, [ order_id ]);

        //render
        return (
            <Modal show={show_payment_modal} onHide={hide_payment_modal}>
                <Modal.Header closeButton>
                    <Modal.Title style={{cursor: 'pointer', fontFamily: 'Montserrat', fontWeight: 400}}>Purchase and download mockup</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {order_final ? (
                        generation_success ? (
                            <Row>
                                <Row className="text-success success text-center">
                                    <span className="fa fa-check fa-2x"/>
                                    <p style={{ fontSize: 14 }}>
                                        Order placed successfully.<br/>
                                        Please wait while your mockup is being rendered. This can take upto a minute.<br/>
                                        You can download the high resolution image now or from your Orders page. <br/>
                                        Thanks for using Mockupmaker.<br/>
                                    </p> 
                                </Row>
                                {download_url?
                                    (<a className="btn btn-blue btn-block" target="blank" href={download_url} download="output.png">Download High Resolution Image</a>):
                                    (<ProgressBar now={render_progress}/>)
                                }
                            </Row>
                        ):(
                            <Row>
                                <Row className="text-danger danger text-center">
                                    <span className="fa fa-times fa-2x"/>
                                    <p style={{ fontSize: 14 }}>
                                        Mockup generated failed. <br/> 
                                        Any amount charged will be refunded in 3-4 working days. <br/>
                                        Contact us at support@designs.ai for any issues. <br/>
                                        Thanks for using Mockupmaker.<br/>
                                    </p> 
                                </Row>
                            </Row>
                        )
                    ):(
                        <React.Fragment>
                            <Row className="text-center" style={{cursor: 'pointer', fontFamily: 'Montserrat', fontWeight: 400}}>
                                <h4>Single Mockup Purchase - ${mockup?mockup.price:2} USD</h4>
                            </Row>
                            <ListGroup componentClass="ul">
                                <ListGroupItem style={{padding: 0}}>
                                    <Panel style={{border: 'none', marginBottom: 0}}>
                                        <Panel.Heading style={heading_style} onClick={() => set_active_tab('stripe')}>
                                            Checkout with card
                                        </Panel.Heading>
                                        <Panel.Body style={{ display: active_tab == 'stripe' ? 'block': 'none' }}>
                                            <StripeProvider apiKey="pk_test_YznMX2VxbUnPultpdYWHoCWK008UAC8CLj">
                                                <Elements>
                                                    <CardForm 
                                                        create_order={create_order} 
                                                        order_id={order_id} 
                                                        handle_result={confirm_order} 
                                                        order_complete={order_complete} 
                                                    />
                                                </Elements>
                                            </StripeProvider>
                                        </Panel.Body>
                                    </Panel>
                                </ListGroupItem>
                                <ListGroupItem style={{padding: 0}}>
                                    <Panel style={{border: 'none', marginBottom: 0}}>
                                        <Panel.Heading style={heading_style} onClick={() => set_active_tab('paypal')}>
                                            Checkout with paypal <br />
                                        </Panel.Heading>
                                        <Panel.Body style={{ display: active_tab == 'paypal' ? 'block': 'none' }}>
                                            <Col xs={3}>
                                            </Col>
                                            <Col xs={6}>
                                                <div onClick={create_order}>
                                                    <div id="paypal-button-container"> This feature is currently under development </div>
                                                </div>
                                            </Col>
                                            <Col xs={3}>
                                            </Col>
                                        </Panel.Body>
                                    </Panel>
                                </ListGroupItem>
                            </ListGroup>
                            <Row>
                                <a className="btn btn-blue-inverse btn-block" download href={window.document.getElementById('result_preview')?window.document.getElementById('result_preview').src:''}>Download Watermarked Image</a>
                            </Row>
                        </React.Fragment>
                    )}
                    {loader_active ? (
                        <div style={{ ...loader_overlay_style, paddingTop: generation_success ? 60 : 150 }}>
                            <strong>Please wait while we generate your mockup.</strong> 
                        </div>
                    ) : ''}
                </Modal.Body>
                <Modal.Footer>
                    <div></div>
                </Modal.Footer>
            </Modal>
        );
    } catch(err) {
        console.log('error in payment modal --> ', err);
        return ''
    }
}


const Color_Picker = ({ show_color_picker, target, selected_color, set_selected_color, hide_color_picker,is_dm }) => {
    try {
        //css
        const container_style = { 
            visibility: 'visible' 
        };
        const popover_style = {
            position: 'absolute',
            zIndex: 2,
            top: '-460px',
            left: '9px'
        };
        const inner_container_style = {
            padding: 0,
            borderRadius: 4,
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px',
            backgroundColor: 'white'
        };
        const cover_style = {
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: '-1'
        };
        const button_container_style = {
            marginTop: 2,
            marginBottom: 5,
            padding: 6
        }
        const button_style = {
            paddingTop: 4,
            paddingBottom: 4
        }

        //state variables
        const default_color = '#333';
        const default_preset_colors = [ '#ffffff', '#f3ec3a', '#f9bd17', '#f99b1d', '#f15523', '#ef3124', '#DE0081', '#a71e48', '#7c3597', '#463191', '#000000', '#3d5dac', '#1296ce', '#63b145', '#19BC81', '#d0dd36' ];
        const [ current_color, set_current_color ] = useState(default_color);
        const [ preset_colors, set_preset_colors ] = useState(default_preset_colors);

        //functions
        const finalize_selection = () => {
            try {
                set_selected_color({ hue_value: current_color });
            } catch(err) {
                console.log('error setting color selection --> ', err);
            }
        }

        //effects
        useEffect(() => {
            if (show_color_picker) {
                if (selected_color) {
                    set_current_color(selected_color);
                } else {
                    set_current_color(default_color);
                }
            }
        }, [ show_color_picker, selected_color ])

        if (show_color_picker) {
            return (
                <div style={container_style}>
                    <div style={popover_style}>
                        <div 
                            style={cover_style} 
                            onClick={hide_color_picker}
                        />
                        <div id="mockup_color_picker_container" style={inner_container_style}>
                            <Colour_Picker 
                                color={current_color} 
                                onChange={ color => set_current_color(color.hsl) } 
                                target={target} 
                                presetColors={preset_colors} 
                            />
                            <Row style={button_container_style}>
                                <Button style={button_style} className={is_dm?"btn-block btn-orange":"btn-block btn-blue"} onClick={finalize_selection}>Apply</Button>                
                            </Row>
                        </div>
                    </div>
                </div>
            )
        } else {
            return ''
        }
    } catch(err) {
        console.log('error in color picker --> ', err);
        return ''   
    }
}


const Color_Picker_Button = ({ selected_color, on_click, caret_container_width, caret_container_height, is_dm}) => {
    try {
        //css
        const container_style = { 
            width: '100%',
            padding: 4,
            paddingRight: 0,
            color: "#2572CE",
            border: "1px solid #2572CE",
            borderRadius: 4,
            cursor: 'pointer'
        };
        const carot_container_style = {
            height: caret_container_height,
            width: caret_container_width,
            display: 'inline-block',
            textAlign: 'center'
        };

        //local state
        const [ current_color, set_current_color ] = useState({ h: 214, s: 8, l: 78, a: 1 });
        const [ color_container_style, set_color_container_style ] = useState({ height: 40 });

        //effects
        useEffect(() => {
            if (selected_color) {
                var { h, s, l, a } = selected_color;
                set_current_color({ h, s: Math.round(s * 100), l: Math.round(l * 100), a });
            }
        }, [ selected_color ])

        useEffect(() => {
            if (current_color) {
                set_color_container_style({
                    display: 'inline-block',  
                    height: caret_container_height,
                    width: `calc(100% - ${caret_container_width}px)`,
                    backgroundColor: `hsla(${current_color.h}, ${current_color.s}%, ${current_color.l}%, ${current_color.a})`,
                    color: 'white'
                })
            }
        }, [ current_color ])

        return (
            <div className="text-center">
                <Row onClick={on_click} style={container_style}>
                    <Col style={color_container_style} >
                        <span style={{ verticalAlign: '-webkit-baseline-middle', color: selected_color ? `hsla(${current_color.h}, ${current_color.s}%, ${current_color.l}%, ${current_color.a})` : 'black'}}>Choose color</span>
                    </Col>
                    <Col style={carot_container_style} >
                        <span style={{ verticalAlign: 'middle', color: 'black', marginTop: 10 }} className="fa fa-lg fa-caret-down" />                        
                    </Col>
                </Row>
            </div>
        )
    } catch(err) {
        console.log('error in color picker container ---> ', err);
        return ''
    }
}

Color_Picker_Button.defaultProps = {
    caret_container_width: 40,
    caret_container_height: 36
}

const MockupEditor = ({ mockup, device_type, saved_mockup, fetch_all_saved_mockups, user,is_dm, apply_mockup_editor }) => {
    try {
        //css
        const result_container_style = {
            padding: 0,
            backgroundColor: 'white', 
            maxWidth: 'calc(100% - 362px)', 
            maxHeight: 'calc(100vh - 100px)'
        };

        const result_container_style_tablet = {
            ...result_container_style,
            maxWidth: '100%',
            maxHeight: 'auto',
            marginTop: (is_dm?10:0)
        }; 

        const result_preview_style = {
            margin: 'auto', 
            width: 'auto', 
            maxWidth: '100%', 
            maxHeight: 500, 
            display: 'block'
        };

        const disabled_button_style = {
            cursor: 'not-allowed',
            opacity: '0.75',
            filter: 'alpha(opacity=75)',
            '-webkit-box-shadow': 'none',
            boxShadow: 'none',
        }


        //state variables
        const [ mockup_name, set_mockup_name ] = useState('');
        const [ loader_init, set_loader_init ] = useState(false);
        const [ mockup_image_src, set_mockup_image_src ] = useState('');
        const [ active_layer, set_active_layer ] = useState(null);
        const [ show_color_picker, set_show_color_picker ] = useState(false);
        const [ color_picker_target, set_color_picker_target ] = useState(false);
        const [ hue_values, set_hue_values ] = useState([]);
        const [ user_images, set_user_images ] = useState([]);
        const [ hue_layer_index_map, set_hue_layer_index_map ] = useState({});
        const [ dynamic_layer_index_map, set_dynamic_layer_index_map ] = useState({});
        const [ selected_color, set_selected_color ] = useState(null);
        const [ show_image_crop_modal, set_show_image_crop_modal ] = useState(false);
        const [ show_image_options_modal, set_show_image_options_modal ] = useState(false);
        const [ past_designs, set_past_designs ] = useState([]);
        const [ allow_save, set_allow_save ] = useState(false);
        const [ allow_download, set_allow_download ] = useState(false);
        const [ show_prompt_message, set_show_prompt_message ] = useState(false);
        const [ show_payment_modal, set_show_payment_modal ] = useState(false);

        //functions
        const fetch_past_designs = async () => {
            try {
                var data = await feline_fetch({ url: 'user/fetch_owned_designs' });
                set_past_designs(data);
            } catch(err) {
                console.log(err)
            }
        }

        const activate_color_picker = ({ layer, target }) => {
            set_active_layer(layer);
            set_color_picker_target(target);
            set_show_color_picker(true);
            set_selected_color(hue_values[hue_layer_index_map[layer._id]] ? hue_values[hue_layer_index_map[layer._id]] : null);
        }

        const hide_color_picker = () => {
            set_show_color_picker(false);
            set_color_picker_target(null);
            set_selected_color(null);
            set_active_layer(null);
        }

        const adjust_image = (layer,idx) => {
            Crop_Editor.destroy_editor();
            Crop_Editor.initialize({  user_image: user_images[idx], active_layer });
            set_show_image_options_modal(false);
            set_show_image_crop_modal(true);
        }

        const remove_user_image = (idx) => {
            var temp = [ ...user_images ];
            temp.splice(idx,1);
            set_user_images(temp);
        }

        const activate_image_options_modal = ({ layer }) => {
            set_active_layer(layer);
            set_show_image_options_modal(true);

        }

        const activate_image_crop_modal = ({ user_image }) => {
            Crop_Editor.destroy_editor();
            Crop_Editor.initialize({ user_image, active_layer });
            set_show_image_options_modal(false);
            set_show_image_crop_modal(true);
        }

        const initiate_image_upload = () => {
            set_show_image_options_modal(false);
            window.document.getElementById('mockup_file').click();
        }

        const update_hue_values = ({ hue_value }) => {
            var temp = [ ...hue_values ];
            temp[hue_layer_index_map[active_layer._id]] = hue_value;
            set_hue_values(temp);
            set_show_color_picker(false);
        }

        const update_user_images = () => {
            try {
                var new_user_image = {
                    src: Crop_Editor.crop_editor.image.src,
                    cropDetails:Crop_Editor.export_crop()
                };
                set_show_image_crop_modal(false);
                var temp = [ ...user_images ];
                temp[dynamic_layer_index_map[active_layer._id]] = new_user_image;
                set_user_images(temp);
            } catch(err) {
                console.log('error in applying crop ---> ', err);
            }
        }

        const regenerate_mockup = async () => {
            try {
                Loader.activate();
                var inputs = { hue_values, user_images };
                var maxWidth = 2 * window.document.getElementById('result_preview').width || 1200;
                var maxHeight = 2 * window.document.getElementById('result_preview').height || 1200;
                var data = await  window.requestGenerateMockup(mockup, { hue_values, user_images }, { maxWidth, maxHeight })
                Loader.hide();
                if (data.response_code == -1) {
                    toastr.error('Oops! Something went wrong.');
                    return Promise.reject(data.error)
                } else if (data.data.error) {
                    toastr.error('Oops! Something went wrong.');
                    return Promise.reject(data.data.error)
                } else {
                    window.document.getElementById('result_preview').src = data.data.data.output;
                    set_allow_download(true);
                    set_allow_save(true);
                }
            } catch(err) {
                console.log("error in mockup generation ----> ", err);
            }
        }

        const save_mockup = async () => {
            try {
                if (allow_save && user) {
                    var image_data = window.document.getElementById('result_preview').src;
                    var data = new FormData();
                    data.append('mockup_file', data_uri_to_blob(image_data), 'output.jpg');
                    var image_srcs = user_images.map( (x, idx) => {
                        if (x && x.src && x.src.indexOf('data:image')>-1) {
                            data.append('mockup_file' + idx, data_uri_to_blob(x.src), 'input_' + idx + '.jpg');
                            delete x.src;
                        }

                        return x;
                    })
                    data.append('mockup_id', mockup._id);
                    data.append('hue_values', JSON.stringify(hue_values ? hue_values : []));
                    data.append('user_images', JSON.stringify(image_srcs ? image_srcs : []));

                    var resp = await feline_fetch({ url: 'mockup/save', body: data, is_form_data: true });
                    fetch_all_saved_mockups();
                    toastr.success('Output saved')
                } else {
                    set_show_prompt_message(true);
                }
            } catch(err) {
                console.log('error in saving mockup --> ', err);
            }
        }

        const download_mockup = () => {
            try {
                if (allow_download && user) {
                    set_show_payment_modal(true);
                } else {
                    set_show_prompt_message(true);
                }
            } catch(err) {
                console.log('error in saving mockup --> ', err);
            }
        }

        const apply_to_design = () => {
            try{
                apply_mockup_editor({
                    id: mockup._id,
                    inputs: { hue_values, user_images }
                })
            }catch(err) {
                console.log('error in saving mockup --> ', err);
            }
        }

        //effects
        useEffect(() => {
            set_hue_layer_index_map({});
            if (!loader_init) {
                Loader.initialize();
                set_loader_init(true);
            }
            if (mockup) {
                set_mockup_name(mockup.name);
                set_mockup_image_src(mockup.placeholders[0] || mockup.tracing_image_src);
                if (mockup.layers && mockup.layers.length) {
                    set_hue_layer_index_map(mockup.layers.filter( x => x.features.hue ).reduce( (final, elem, idx) => ({ ...final, [elem._id]: idx }), {} ) );
                    set_dynamic_layer_index_map(mockup.layers.filter( x => x.type == 'dynamic' ).reduce( (final, elem, idx) => ({ ...final, [elem._id]: idx }), {} ) );
                }
            }
        }, [ mockup ]);

        useEffect(() => {
            if (saved_mockup) {
                var inputs = saved_mockup.mockup_inputs;
                if (inputs.hue_values && inputs.hue_values.length) {
                    set_hue_values(inputs.hue_values)
                }
                if (inputs.user_images && inputs.user_images.length) {
                    set_user_images(inputs.user_images);
                }
                set_mockup_image_src(saved_mockup.watermarked_output_src);
            } else if (mockup) {
                set_hue_values([]);
                set_user_images([]);
            }
        }, [ saved_mockup, mockup ])

        useEffect(() => {
            if (show_image_options_modal) {
                fetch_past_designs();
            }
        }, [ show_image_options_modal ]);

        useEffect(() => {
            // if (hue_values.length || user_images.length) {
                regenerate_mockup();
            // }
        }, [ hue_values, user_images ])

        useEffect(() => {
            if (allow_save || allow_download) {
                set_show_prompt_message(false);
            }
        }, [ allow_download, allow_save ])

        const convert_src = (src) => {
            if(!src){
                return '';
            }

            if (src.indexOf('data:image')>-1 || src.indexOf('http')>-1 || src.indexOf('blob:')>-1) {
                if(src.indexOf('blob:')>-1 || src.indexOf('data:image')>-1){
                    return src;  
                }else{
                    return global.config.server_path.replace('api/','')+'api/image_proxy?src='+window.encodeURIComponent(src)
                }
            } else {
                return global.config.server_path + src
            }
        }


        //render
        return (
            <Row>
                <Image_Options_Modal
                    show_image_options_modal={show_image_options_modal}
                    hide_image_options_modal={() => set_show_image_options_modal(false)}
                    past_designs={past_designs}
                    activate_image_crop_modal={activate_image_crop_modal}
                    initiate_image_upload={initiate_image_upload}
                    is_dm={is_dm}
                />
                <Image_Crop_Modal
                    show_image_crop_modal={show_image_crop_modal}
                    hide_image_crop_modal={() => set_show_image_crop_modal(false)}
                    update_user_images={update_user_images}
                    is_dm={is_dm}
                />
                <Payment_Modal 
                    show_payment_modal={show_payment_modal}
                    hide_payment_modal={() => set_show_payment_modal(false)}
                    mockup={mockup}
                    inputs={{ hue_values, user_images }}
                    payment_completion={() => set_allow_download(false)}
                    user={user}
                    is_dm={is_dm}
                />
                {device_type == 'tablet' ? (<Col xs={2} />) : ''}
                <Col xs={12} sm={8} id="result_container" style={device_type == 'tablet' ? result_container_style_tablet : result_container_style}>
                    <div id="result_loader" className="bodymovin-wrapper loader" style={{ display: 'none' }} />
                    <div id="result_overlay" className="bodymovin loader_overlay" style={{ display: 'none' }} />
                    <Image 
                        id="result_preview" 
                        style={result_preview_style} 
                        className="mockup_image_big" 
                        src={convert_src(mockup_image_src)} 
                        rounded
                    />
                </Col>

                {device_type == 'tablet' ? (<Col xs={4} style={{ marginLeft: '-44px' }} />) : ''}
                <Col xs={12} sm={4} style={{minWidth: is_dm?290:338}}>
                    <div style={{marginTop: (is_dm?10:0), width: '100%', padding: 20, float:'right', marginLeft: 24, borderRadius: 4, boxShadow: '0 5px 20px 0 rgba(0,0,0,0.1)'}}>
                        <Row>
                            <span style={{fontSize: 18, fontFamily: 'Montserrat', fontWeight: 800}}>{mockup_name}</span>
                        </Row>
                        <hr />
                        <Row>
                            {/* Image Uploads */}
                            {mockup && mockup.layers.filter(layer => layer.type == 'dynamic').map((layer,idx) => (       
                                <Row style={{ marginBottom: 14 }}>
                                    <div style={{marginBottom: 10, fontFamily: "Montserrat", fontSize: 14, fontWeight: 800}}>{layer.name}</div>
                                    {user_images[idx]?(
                                        <Row>
                                            <Col xs={10}>
                                                <Button className={is_dm?"btn-block btn-orange-inverse":"btn-block btn-blue-inverse"} onClick={() => adjust_image(layer,idx)}>Adjust Image</Button>
                                            </Col>
                                            <Col xs={2}>
                                                <Button className={is_dm?"btn-block btn-orange-inverse":"btn-block btn-blue-inverse"} onClick={() => remove_user_image(idx)}>✖</Button>
                                            </Col> 
                                        </Row>
                                    ):(
                                        <Button className={is_dm?"btn-block btn-orange-inverse":"btn-block btn-blue-inverse"} onClick={() => activate_image_options_modal({ layer })}>Upload Image</Button>
                                    )}
                                    
                                </Row>
                            ))}
                            <hr />

                            {/* Color pickers */}
                            {mockup && mockup.layers.filter(layer => (layer.features && layer.features.hue)).map(layer => (
                                <Row style={{ marginBottom: 14 }}>
                                    <div style={{marginBottom: 10, fontFamily: 'Montserrat', fontWeight: 800, fontSize: 14}}>{layer.name}</div>
                                        <Color_Picker_Button 
                                            selected_color={hue_values[hue_layer_index_map[layer._id]]}
                                            on_click={({target}) => activate_color_picker({ layer, target })}
                                            is_dm={is_dm}
                                        />
                                </Row>
                            ))}
                            <hr />

                            {/* Popover for color pickers */}
                            <Overlay show={show_color_picker} target={color_picker_target} placement="bottom">
                                <Popover id="popover-contained" style={{ visibility: 'hidden'}} >
                                    <Color_Picker 
                                        show_color_picker={show_color_picker}
                                        hide_color_picker={hide_color_picker}
                                        target={color_picker_target}
                                        selected_color={selected_color}
                                        set_selected_color={update_hue_values}
                                        is_dm={is_dm}
                                    />
                                </Popover>
                            </Overlay> 
                            
                            {/* File input for image upload */}
                            <input type="file" onInput={() => activate_image_crop_modal({})} onClick={(event) => {event.target.value = null}} id="mockup_file" name="mockup_image"/>
                        </Row>
                        {!is_dm?(
                            <Row>
                                <Col xs={6} style={{ paddingLeft: 0, paddingRight: 4 }}>
                                    <Button onClick={download_mockup} className="btn-blue btn-block" style={(!allow_download || !user) ? disabled_button_style : {} }>Download</Button>
                                </Col>
                                <Col xs={6} style={{ paddingRight: 0, paddingLeft: 4 }}>
                                    <Button onClick={save_mockup} className="btn-blue btn-block" style={(!allow_save || !user) ? disabled_button_style : {} }>Save</Button>
                                </Col>
                            </Row>
                        ):(
                            <Row>
                                <Col xs={12} style={{ paddingLeft: 0, paddingRight: 4 }}>
                                    <Button onClick={apply_to_design} className="btn-orange btn-block">Apply to design</Button>
                                </Col>
                                
                            </Row>

                        )}
                        {show_prompt_message && (
                            <Row style={{ color: 'red', fontSize: 10, textAlign: 'center' }}>
                                <br/>
                                <strong>{user ? 'Please alter the mockup to enable this feature.' : 'Please Login to enable this feature.'}</strong>
                            </Row>
                        )}
                    </div>
                </Col>
            </Row>
        );
    } catch(err) {
        console.log('error in mockup panel --> ', err);
        return '';
    }
}


const mapStateToProps = function(state) {
    return {
        show_upload_mockup_modal: state.display_upload_mockup_modal,
        user: state.user
     }
}

const mapDispatchToProps = dispatch => {
    return {
        create_order: (email, amount, coupon_code) => {
            return dispatch(create_order(email, amount, coupon_code))
        }
    }
}

export default withRouter(MockupEditor);